export enum PageTypes {
  Entity = 'entity',
  Group = 'group',
}
